import iconDashboard from '../../../assets/icons/dashboard.svg'
import iconPayer from '../../../assets/icons/payer.svg'
import iconSettings from '../../../assets/icons/config.svg'

const DefaultStore = {
    showMenu: false,
    activeItem: 0,
    items: [{
            text: "Dashboard",
            icon: iconDashboard,
            permissions: [],
            subItems: []
        },
        {
            text: "Prepaid",
            icon: iconPayer,
            permissions: [1,21,22,27,82,84],
            subItems: [
                {
                    url: "/prepaid/customer/all",
                    text: "Customers",
                    permissions: [1,21,22,27],
                },
                {
                    url: "/prepaid/sale/all",
                    text: "Sales",
                    permissions: [1,82,84]
                }
            ]
        },
        {
            text: "Report",
            icon: iconPayer,
            permissions: [1],
            subItems: [
                {
                    url: "/report/customer/all",
                    text: "Customers",
                    permissions: [1],
                },
                {
                    url: "/report/sale/all",
                    text: "Sales",
                    permissions: [1]
                }
            ]
        },
        {
            text: "Internet",
            icon: iconSettings,
            permissions: [1,51],
            subItems: [{
                    url: "/internet/plans",
                    text: "Plans",
                    permissions: [1,51]
                },
                {
                    url: "/internet/profile/all",
                    text: "Profiles",
                    permissions: [1]
                },
                {
                    url: "/internet/nas/all",
                    text: "Nas",
                    permissions: [1]
                },
                {
                    url: "/internet/site/all",
                    text: "Sites",
                    permissions: [1]
                },
                {
                    url: "/internet/locations/all",
                    text: "Locations",
                    permissions: [1]
                },
                {
                    url: "/internet/salepoints/all",
                    text: "SalePoints",
                    permissions: [1]
                },
            ]
        },
        {
            text: "Security",
            icon: iconSettings,
            permissions: [1],
            subItems: [{
                    url: "/security/users/all",
                    text: "Users",
                    permissions: [1]
                },
                {
                    url: "/security/roles/all",
                    text: "Roles",
                    permissions: [1]
                }
            ]
        }
    ]
}

export default DefaultStore